module.exports = __webpack_public_path__ + "img/down_display.a35756c5.svg";